import React, { createContext, useContext } from 'react';

import { Tooltip } from '@fly/core';

export const SearchContext = createContext<{
  search: string;
  setSearch: (search: string) => void;
}>({
  search: '',
  setSearch: () => {},
});

export const Search = ({
  text,
  maxLength = Infinity,
  className,
  ref,
}: {
  text: string;
  maxLength?: number;
  className?: string;
  ref?: React.Ref<HTMLSpanElement>;
}) => {
  const { search } = useContext(SearchContext);

  const truncatedText = text.slice(0, maxLength);
  const isTruncated = text.length > maxLength;

  let content: React.ReactNode = truncatedText;
  const searchValue = search?.trim() || '';

  if (searchValue) {
    const regex = new RegExp(
      `(${searchValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
      'i'
    );
    const parts = truncatedText.split(regex);

    content = parts.map((part, idx) => {
      if (regex.test(part)) {
        return (
          <span
            key={idx}
            data-testid='search-highlight'
            className='bg-fly-general-black text-fly-general-white'
          >
            {part}
          </span>
        );
      }
      return <span key={idx}>{part}</span>;
    });
  }

  return (
    <>
      {isTruncated ? (
        <Tooltip content={text} selectable>
          <span ref={ref} className={className}>
            {content}…
          </span>
        </Tooltip>
      ) : (
        <span ref={ref} className={className}>
          {content}
        </span>
      )}
    </>
  );
};
